"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combineStyle = void 0;

var _utils = require("../../utils");

var _fullWidth = require("./full-width");

var _display = require("./display");

var _align = require("./align");

var _float = require("./float");

var _bg = require("./bg");

var _bgImage = require("./bg-image");

var _alignItems = require("./align-items");

var _justifyContent = require("./justify-content");

var _color = require("./color");

var _fontFamily = require("./font-family");

var _fontWeight = require("./font-weight");

var _clearfix = require("./clearfix");

var _spacing = require("./spacing");

var _border = require("./border");

var _wordBreak = require("./word-break");

var _textDecoration = require("./text-decoration");

var _whiteSpace = require("./white-space");

var _alignContent = require("./align-content");

var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var combineStyle = function combineStyle(props) {
  var fullWidth = props.fullWidth,
      $display = props.$display,
      align = props.align,
      float = props.float,
      bg = props.bg,
      bgImage = props.bgImage,
      $color = props.$color,
      fontFamily = props.fontFamily,
      fontWeight = props.fontWeight,
      clearfix = props.clearfix,
      border = props.border,
      alignItems = props.alignItems,
      alignContent = props.alignContent,
      justifyContent = props.justifyContent,
      wordBreak = props.wordBreak,
      whiteSpace = props.whiteSpace,
      textDecoration = props.textDecoration,
      m = props.m,
      mt = props.mt,
      mr = props.mr,
      mb = props.mb,
      ml = props.ml,
      p = props.p,
      pt = props.pt,
      pr = props.pr,
      pb = props.pb,
      pl = props.pl;
  return (0, _utils.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n  "])), fullWidth && (0, _fullWidth.fullWidthHelperStyle)(fullWidth), $display && (0, _display.displayHelperStyle)($display), align && (0, _align.alignHelperStyle)(align), float && (0, _float.floatHelperStyle)(float), bg && (0, _bg.bgHelperStyle)(bg), bgImage && (0, _bgImage.bgImageHelperStyle)(bgImage), alignItems && (0, _alignItems.alignItemsHelperStyle)(alignItems), alignContent && (0, _alignContent.alignContentHelperStyle)(alignContent), justifyContent && (0, _justifyContent.justifyContentHelperStyle)(justifyContent), $color && (0, _color.colorHelperStyle)($color), fontFamily && (0, _fontFamily.fontFamilyHelperStyle)(fontFamily), fontWeight && (0, _fontWeight.fontWeightHelperStyle)(fontWeight), clearfix && _clearfix.clearfixHelperStyle, border && (0, _border.borderHelperStyle)(border), wordBreak && (0, _wordBreak.wordBreakHelperStyle)(wordBreak), whiteSpace && (0, _whiteSpace.whiteSpaceHelperStyle)(whiteSpace), textDecoration && (0, _textDecoration.textDecorationHelperStyle)(textDecoration), (0, _spacing.spacingStyle)({
    m: m,
    mt: mt,
    mr: mr,
    mb: mb,
    ml: ml,
    p: p,
    pt: pt,
    pr: pr,
    pb: pb,
    pl: pl
  }));
};

exports.combineStyle = combineStyle;